import { createSelector } from 'reselect';
import { GATES } from '../utils/constants';
import { selectAuthGatesSet } from './AuthSelectors';
export const selectHasNewToYouGate = createSelector([selectAuthGatesSet], gateSet => gateSet.has(GATES.NEW_TO_YOU_GATE));
export const selectHasPmOutreachGate = createSelector([selectAuthGatesSet], gateSet => gateSet.has(GATES.PM_OUTREACH_GATE));